import { TableFilterModel } from "models/TableFilterModel";
import { IWorkflowGridDetail } from "models/WorkFlow/WorkflowGridDetailModel";
import { IWorkflowNumber } from "models/WorkFlow/WorkflowNumberModel";
import { IWorkflowStatus } from "models/WorkFlow/WorkflowStatusModel";
import { IWorkflowType } from "models/WorkFlow/WorkflowTypeModel";
import { BaseService } from "services/base.service";
import WorkflowDetailModel from "models/WorkFlow/WorkflowDetailModel";
import { ITableNumberColumnFilter } from "models/TableNumberColumnFilter";
import { ITransactionType } from "models/TransactionTypeModel";

class WorkflowServiceInternal extends BaseService {
	getWorkFlowList = async (
		model: TableFilterModel
	): Promise<IWorkflowGridDetail[]> =>
		this.callApi<IWorkflowGridDetail[]>(
			`Workflow/GetWorkflowList`,
			"POST",
			undefined,
			model
		);

	getWorkflowNumberList = async (
		model: ITableNumberColumnFilter
	): Promise<IWorkflowNumber[]> =>
		this.callApi<IWorkflowNumber[]>(
			`Workflow/GetWorkflowNumberList`,
			"POST",
			undefined,
			model
		);

	getWorkFlowStatusList = async (): Promise<IWorkflowStatus[]> =>
		this.callApi<IWorkflowStatus[]>(
			`WorkflowStatus/GetWorkflowStatusList`,
			"GET"
		);

	getWorkFlowTypeList = async (): Promise<IWorkflowType[]> =>
		this.callApi<IWorkflowType[]>(`WorkflowType/GetWorkflowTypeList`, "GET");

	getWorkFlowDetail = async (
		workflowId: number
	): Promise<WorkflowDetailModel> =>
		this.callApi<WorkflowDetailModel>(
			`Workflow/GetWorkflowData/${workflowId}`,
			"GET"
		);

	saveWorkFlowDetail = async (
		model: WorkflowDetailModel,
		isForceInActive: boolean = false
	): Promise<{ workflowId: number; workflowNumber: string }> =>
		this.callApi<{ workflowId: number; workflowNumber: string }>(
			`Workflow/Save`,
			"POST",
			new URLSearchParams({
				isForceInActive: isForceInActive.toString(),
			}),
			model
		);

	updateWorkFlowDetail = async (
		model: WorkflowDetailModel,
		isForceInActive: boolean = false
	): Promise<undefined> =>
		this.callApi<undefined>(
			`Workflow/Update/${model.workflowId}`,
			"PUT",
			new URLSearchParams({
				isForceInActive: isForceInActive.toString(),
			}),
			model
		);

	deleteWorkFlowDetail = async (workflowId: number): Promise<undefined> =>
		this.callApi<undefined>(`Workflow/Delete/${workflowId}`, "DELETE");

	getTransactionTypeList = async (
		workflowTypeId: number,
		moduleId: number
	): Promise<ITransactionType[]> => {
		let urlParams = {} as any;
		if (moduleId > 0) {
			urlParams["moduleId"] = moduleId.toString();
		}

		return this.callApi<ITransactionType[]>(
			`WorkflowTransactionType/GetTransactionTypeList/${workflowTypeId}`,
			"GET",
			new URLSearchParams(urlParams)
		);
	};

	isCheckActiveWorkflowExist = async (
		erpDbCompanyId: number,
		moduleId: number,
		transactionTypeId: number,
		workflowId: number
	): Promise<boolean> => {
		let urlParams = {} as any;
		if (transactionTypeId > 0) {
			urlParams["transactionTypeId"] = transactionTypeId.toString();
		}
		if (workflowId > 0) {
			urlParams["workflowId"] = workflowId.toString();
		}

		return this.callApi<boolean>(
			`Workflow/IsCheckActiveWorkflowExist/${erpDbCompanyId}/${moduleId}`,
			"GET",
			new URLSearchParams(urlParams)
		);
	};
	activateDeactivateWorkflow = async (
		workflowId: number,
		isActive: boolean,
		isForceInActive: boolean = false
	): Promise<number> => {
		return this.callApi<number>(
			`Workflow/UpdateWorkFlowStatus/${workflowId}/${isActive}/${isForceInActive}`,
			"PUT"
		);
	};
}

export const WorkflowService = new WorkflowServiceInternal();
